import { cn } from "@/lib/utils";
import { ArrowRight, Ban } from "lucide-react";
import { recipientChipClassName } from "./RecipientChip";

export type RecipientDropState = "idle" | "accepted" | "forbidden";

type RecipientDragPreviewProps = {
    email: string;
    dropState: RecipientDropState;
    targetLabel?: string;
};

const RecipientDragPreview = ({
    email,
    dropState,
    targetLabel,
}: RecipientDragPreviewProps) => (
    <div
        className={cn(
            recipientChipClassName,
            "w-fit gap-1.5 scale-105 border-primary-light text-primary-dark shadow-lg",
            "animate-in fade-in-0 zoom-in-95 duration-150",
            dropState === "accepted" && "bg-surface-activeFg",
            dropState === "forbidden" &&
                "border-neutral-light bg-neutral-lightest text-text-caption",
        )}
    >
        {dropState === "forbidden" && (
            <Ban className="h-3.5 w-3.5 animate-in zoom-in-50 duration-150" />
        )}
        {email}
        {dropState === "accepted" && targetLabel && (
            <span className="flex items-center gap-1 rounded-full bg-primary-dark px-1.5 text-xs text-white animate-in fade-in-0 slide-in-from-left-1 duration-150">
                <ArrowRight className="h-3 w-3" />
                {targetLabel}
            </span>
        )}
    </div>
);

export default RecipientDragPreview;
